import { useState, useEffect } from "react";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { detectLang, t } from "../i18n";
import "./Login.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [lang, setLangState] = useState(detectLang());
  const navigate = useNavigate();
  const auth = getAuth();

  useEffect(() => {
    localStorage.setItem("lang", lang);
  }, [lang]);

  const handleLang = (l) => {
    setLangState(l);
    localStorage.setItem("lang", l);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/biblioteca");
    } catch (err) {
      setError(
        lang === "es"
          ? "Email o contraseña incorrectos"
          : "Incorrect email or password"
      );
    }
  };

  return (
    <div className="login-screen">
      <div className="login-left">

        <div className="lang-switcher">
  <button
    className={`lang-btn ${lang === "es" ? "active" : ""}`}
    onClick={() => handleLang("es")}
  >
    <img src="https://flagcdn.com/w20/es.png" alt="ES" style={{width:20, borderRadius:2}} />
  </button>
  <button
    className={`lang-btn ${lang === "en" ? "active" : ""}`}
    onClick={() => handleLang("en")}
  >
    <img src="https://flagcdn.com/w20/us.png" alt="EN" style={{width:20, borderRadius:2}} />
  </button>
</div>

        <div className="brand">
          <div className="brand-icon">
            <svg viewBox="0 0 24 24">
              <path d="M12 2L2 7l10 5 10-5-10-5z" />
              <path d="M2 17l10 5 10-5" />
              <path d="M2 12l10 5 10-5" />
            </svg>
          </div>
          <div className="brand-name">
            AFILIADOS<span>MARKET</span>
          </div>
        </div>

        <h1 className="login-title">{t(lang, "login", "title")}</h1>
        <p className="login-sub">{t(lang, "login", "sub")}</p>

        {error && <div className="login-error">{error}</div>}

        <form onSubmit={handleLogin}>
          <label className="field-label">{t(lang, "login", "email")}</label>
          <input
            className="field-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="tu@email.com"
            required
          />

          <label className="field-label">{t(lang, "login", "password")}</label>
          <input
            className="field-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            required
          />

          <button className="btn-primary" type="submit">
            <svg viewBox="0 0 24 24">
              <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
              <polyline points="10 17 15 12 10 7" />
              <line x1="15" y1="12" x2="3" y2="12" />
            </svg>
            {t(lang, "login", "btn")}
          </button>
        </form>

        <div className="divider">
          <div className="divider-line"></div>
          <span className="divider-text">{t(lang, "login", "or")}</span>
          <div className="divider-line"></div>
        </div>

        <button
          className="btn-secondary"
          onClick={() => navigate("/registro")}
        >
          {t(lang, "login", "register")}
        </button>

      </div>

      <div className="login-right">
        <div className="login-stat">
          <div className="login-stat-num">+500</div>
          <div className="login-stat-label">{t(lang, "login", "stat")}</div>
        </div>
        <div className="login-badges">
          <div className="login-badge"><span>✓</span> {t(lang, "login", "b1")}</div>
          <div className="login-badge"><span>✓</span> {t(lang, "login", "b2")}</div>
          <div className="login-badge"><span>✓</span> {t(lang, "login", "b3")}</div>
          <div className="login-badge"><span>✓</span> {t(lang, "login", "b4")}</div>
        </div>
      </div>

    </div>
  );
};

export default Login;